import { render, staticRenderFns } from "./situation-inner.vue?vue&type=template&id=885e2c50&"
import script from "./situation-inner.vue?vue&type=script&lang=js&"
export * from "./situation-inner.vue?vue&type=script&lang=js&"
import style0 from "./situation-inner.vue?vue&type=style&index=0&id=885e2c50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports